<template>
    <nav>
        <ul class="sidebar">
                <router-link tag="li" to="/" class="sidebar-li " :id="[$route.name == 'Accueil' ? 'rouge' : '']">
                    <img src="../assets/logo/picto_Accueil.png" class="puce-nav" alt="logo accueil" @mouseover="pointerHover('logo_accueil')"  v-if="imgHover !== 'logo_accueil' && $route.name !== 'Accueil'">
                    <img src="../assets/logo/picto_Accueil_rouge.png" class="puce-nav" alt="logo accueil" @mouseleave="pointerHover(false)"  v-if="imgHover == 'logo_accueil'|| $route.name == 'Accueil'">
                    <div class="hidePuce">Accueil</div>
                </router-link>   
                <router-link tag="li" to="/session" title="Session individuel" class="sidebar-li side2" :id="[$route.name == 'Session_Individuelle' ? 'rouge' : '']">
                    <img src="../assets/logo/picto_NouvelleSession.png" class="puce-nav" alt="logo althère" @mouseover="pointerHover('logo_althère')"  v-if="imgHover !== 'logo_althère' && $route.name !== 'Session_Individuelle'">
                    <img src="../assets/logo/picto_NouvelleSession_rouge.png" class="puce-nav" alt="logo althère" @mouseleave="pointerHover(false)"  v-if="imgHover == 'logo_althère' || $route.name == 'Session_Individuelle'">
                    <div class="hidePuce">Session</div>
                </router-link>
                <router-link tag="li" to="/statistiques" title="Statistiques" class="sidebar-li side3" :id="[$route.name == 'Statistiques' ? 'rouge' : '']">
                    <img src="../assets/logo/picto_Resultats.png" class="puce-nav" alt="logo loupe" @mouseover="pointerHover('logo_loupe')"  v-if="imgHover !== 'logo_loupe' && $route.name !== 'Statistiques'">
                    <img src="../assets/logo/picto_Resultats_rouge.png" class="puce-nav" alt="logo loupe" @mouseleave="pointerHover(false)" v-if="imgHover == 'logo_loupe' || $route.name == 'Statistiques'">
                    <div class="hidePuce">Statistiques</div>
                </router-link>
                <router-link tag="li" to="/test" title="Test" class="sidebar-li side4" :id="[$route.name == 'Test' ? 'rouge' : '']">
                    <img src="../assets/logo/picto_Reevaluation.png" class="puce-nav" alt="logo crayon" @mouseover="pointerHover('crayon')"  v-if="imgHover !== 'crayon' && $route.name !== 'Test'">
                    <img src="../assets/logo/picto_Reevaluation_rouge.png" class="puce-nav rouge" alt="logo crayon" @mouseleave="pointerHover(false)" v-if="imgHover == 'crayon'|| $route.name == 'Test'">
                    <div class="hidePuce">Evaluation</div>
                </router-link>
                <router-link tag="li" to="/exercices_favories" title="Favories" class="sidebar-li side5" :id="[$route.name == 'Favories' ? 'rouge' : '']">
                    <img src="../assets/logo/picto_Exercices.png" class="puce-nav" alt="logo photo" @mouseover="pointerHover('logo_photo')"  v-if="imgHover !== 'logo_photo' && $route.name !== 'Favories'">
                    <img src="../assets/logo/picto_Exercices_rouge.png" class="puce-nav" alt="logo photo" @mouseleave="pointerHover(false)"  v-if="imgHover == 'logo_photo' || $route.name == 'Favories'">
                    <div class="hidePuce">Mes Exercices</div>
                </router-link>
        </ul>
    </nav>
    
</template>

<script>

export default {
    name: 'Sidebar',
    data() {
        return {
            imgHover: false,
        };
    },
    methods: {
        pointerHover(li) {
            return this.imgHover = li; 
        },
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Sidebar.vue